import { render } from "./OrderActors.vue?vue&type=template&id=df09892e&scoped=true"
import script from "./OrderActors.vue?vue&type=script&lang=js"
export * from "./OrderActors.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"
import "./OrderActors.vue?vue&type=style&index=1&id=df09892e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df09892e"]])

export default __exports__